import { template21, template22, template23, template24 } from "assets/images";
import React from "react";
import { useTranslation } from "react-i18next";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link, useSearchParams } from "react-router-dom";
import { handleEncryptionParams } from "utils/dataCipherHelper";
import { survey } from "validation/schema/survey";

const SurveyTemplateList = ({ templateList }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { t, i18n } = useTranslation();

  const stepperValueHandler = (item) => {
    const paramsData = {
      stepper: 2,
      isTemplate: true,
      surveyTitle: item?.title[i18n.language],
      surveyDescription: item?.description[i18n.language],
      selectedCategory: item?.categoryId?.name,
      selectedCategoryId: item?.categoryId?._id,
      surveyTemplateSlug: item?.surveyCategorySlug,
    };
    const encryptedParams = handleEncryptionParams(paramsData, searchParams);
    setSearchParams(encryptedParams);
  };

  //****************************  Handle All HTML CODE ****************************//
  return (
    <div>
      <h3>{t("CREATE_SURVEY.selectTemplate")}</h3>
      <div className="template_wrap">
        {templateList?.length > 0 &&
          templateList?.map((item, ind) => (
            <div className="template_card" key={item?._id}>
              <div className="image_wrap">
                <img src={item?.templateImage || ""} alt="not-found" />
              </div>
              <div className="content">
                <h4>{item?.title[i18n?.language] || "-----"}</h4>
                <p>{item?.description[i18n.language] || "-----"}. </p>

                <button onClick={() => stepperValueHandler(item)}>
                  {`${t("CREATE_SURVEY.selectTemplate")} `}
                  <FaArrowRightLong />
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default SurveyTemplateList;
